import ChesseImg from '../../assests/images/card_chesse.svg';
import CloudImg from '../../assests/images/card_clouds.svg';
import DayLightImg from '../../assests/images/card_light.svg';
import NightLightImg from '../../assests/images/card_light_dark.svg';
import ScrapperImg from '../../assests/images/card_scrapper.svg';
import BrightHappyImg from '../../assests/images/card_bright_happy.svg';
import TressImg from '../../assests/images/card_trees.svg';
import PartyLightImg from '../../assests/images/card_light_party.svg';
import IceImg from '../../assests/images/card_ice.svg';
import CandyImg from '../../assests/images/card_candy.svg';
import Img1 from '../../assests/images/card_1.svg';
import Img2 from '../../assests/images/card_2.svg';
import Img3 from '../../assests/images/card_3.svg';
import Img4 from '../../assests/images/card_4.svg';
import Img5 from '../../assests/images/card_5.svg';
import Img6 from '../../assests/images/card_6.svg';

export const cardItems = [
  {
    id: 1,
    image: `${ScrapperImg}`,
  },
  {
    id: 2,
    image: `${BrightHappyImg}`,
  },
  {
    id: 3,
    image: `${TressImg}`,
  },
  {
    id: 4,
    image: `${PartyLightImg}`,
  },
  {
    id: 5,
    image: `${ChesseImg}`,
  },
  {
    id: 6,
    image: `${CloudImg}`,
  },
  {
    id: 7,
    image: `${DayLightImg}`,
  },
  {
    id: 8,
    image: `${NightLightImg}`,
  },
  {
    id: 9,
    image: `${Img6}`,
  },
  {
    id: 10,
    image: `${IceImg}`,
  },
  {
    id: 11,
    image: `${CandyImg}`,
  },
  {
    id: 12,
    image: `${Img1}`,
  },
  {
    id: 13,
    image: `${Img2}`,
  },
  {
    id: 14,
    image: `${Img3}`,
  },
  {
    id: 15,
    image: `${Img4}`,
  },
  {
    id: 16,
    image: `${Img5}`,
  },
];
